import React from 'react';
import { GridItem } from '@nike/nike-design-system-components';
import '@nike/nike-design-tokens/dist/css/tokens.css';
import { DividerProps } from '../../types/DividerProps';
import styled from '@emotion/styled';

const StyledGridItem = styled(GridItem)`
  border-color: var(--podium-cds-color-border-disabled);
  border-top-width: var(--podium-cds-size-border-width-s);
  border-top-style: solid;
  width: 100%;
  height: 1px;
  padding-bottom: var(--podium-cds-size-spacing-l);
  margin-top: var(--podium-cds-size-spacing-l);
`;

const Divider: React.FC<DividerProps> = ({ xs }) => {
  return <StyledGridItem xs={xs} />;
};

export default Divider;
